import React from 'react';
import { cn } from '../utils/cn';

interface LogoProps {
    className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className }) => {
    return (
        <svg 
            className={cn("w-10 h-10 text-blue-600 flex-shrink-0", className)} 
            viewBox="0 0 52 52" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <g stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                {/* Hexagon Outline */}
                <polygon points="50,26 38,46.78 14,46.78 2,26 14,5.22 38,5.22" />
                
                {/* Spokes connecting center to corners */}
                <line x1="26" y1="26" x2="50" y2="26" />
                <line x1="26" y1="26" x2="38" y2="46.78" />
                <line x1="26" y1="26" x2="14" y2="46.78" />
                <line x1="26" y1="26" x2="2" y2="26" />
                <line x1="26" y1="26" x2="14" y2="5.22" />
                <line x1="26" y1="26" x2="38" y2="5.22" />
            </g>
            <g fill="currentColor">
                {/* Center Node */}
                <circle cx="26" cy="26" r="3" />
                
                {/* Corner Nodes */}
                <circle cx="50" cy="26" r="3" />
                <circle cx="38" cy="46.78" r="3" />
                <circle cx="14" cy="46.78" r="3" />
                <circle cx="2" cy="26" r="3" />
                <circle cx="14" cy="5.22" r="3" />
                <circle cx="38" cy="5.22" r="3" />
            </g>
        </svg>
    );
};
